import adminApi from './adminAPI';

export const adminDashboardAPI = {
  async obterResumo() {
    const { data } = await adminApi.get('/dashboard');
    return data;
  }
};

export default adminDashboardAPI;
